import React from 'react'
import Styled from 'styled-components'

import { withRouter } from 'router/index'

import Icon from 'components/Icon'
import Link from 'components/Link'

const Container = Styled(Link)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 2rem;
  color: ${props => props.theme.colors.gray.shade200};
  transition: 300ms;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.gray.shade300};
  }

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background-color: ${props => props.theme.colors.primary.shade400};
    transform: translate3d(-50%, 0, 0);
    transition: 300ms;
  }

  ${props => props.active && `
    color: ${props.theme.colors.gray.shade700};
    
    &:after {
      width: 100%;
    }
  `}
`

const IconExtended = Styled(Icon)`
  font-size: 1.75rem;
`

const Label = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-top: 0.25rem;
`

export default withRouter(props => (
  <Container
    to={props.to}
    active={props.location.pathname === props.to ? 1 : 0}
  >
    <IconExtended liga={props.liga} />
    <Label>{props.label}</Label>
  </Container>
))



// WEBPACK FOOTER //
// ./src/components/NavigationMode/index.js